import {MobileDateTimePicker} from "@mui/x-date-pickers";
import {InputAdornment} from "@mui/material";
import {CalendarMonth} from "@mui/icons-material";
import dayjs from "dayjs";
import {DemoItem} from "@mui/x-date-pickers/internals/demo";
import {useEffect} from "react";
import {ZonedDateTime, ZoneId} from "@js-joda/core";

export default function ({onChange}) {

    useEffect(() => {
        onChange(ZonedDateTime.now(ZoneId.of("Europe/Paris")).toString());
    }, []);

    return (
        <DemoItem label={"Quelle est la date prévue pour l'intervention ? (maintenant ou planifié)"}>
            <MobileDateTimePicker
                ampm={false}
                slotProps={{
                    textField: {
                        fullWidth: true,
                        InputProps: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <CalendarMonth/>
                                </InputAdornment>
                            ),
                        },
                        "data-test": "input-second-appointment"
                    }
                }}
                defaultValue={dayjs(new Date())}
                onChange={(val) => onChange(dayjs(val).toISOString())}
            />
        </DemoItem>
    )
}